import { useContext, useEffect } from 'react';
import { BasicScrollView } from "@/components/BasicScrollView";
import { CustomText } from '@/components/CustomText';
import * as AppUtils from '@/utilities/AppUtils';
import { useRouter } from 'expo-router';
import { useDispatch } from 'react-redux';
import { Meta } from '@/components/Meta';
import { AppContext } from '@/components/AppContext';

export default function Logout() {
  const router = useRouter();
  const { showSpinner, hideSpinner } = useContext(AppContext);
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      await AppUtils.logout(dispatch, showSpinner, hideSpinner);
      router.replace("/loggedout");
    })();
  }, []);
  
  return (
    <BasicScrollView center={true}>
      <Meta title={"Logout"} />
      <CustomText>Logging out...</CustomText>
    </BasicScrollView>
  );
}
